// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylus/main.styl
// module id = 704
// module chunks = 1